const theme = {
  loaded: true,
  unit: "px",
  base: "",

  fontSize: {
    heading: 55,
    heading1: 40,
    heading2: 20,
    heading3: 18,
    heading4: 14,
    text1: 16,
    text2: 15,
    text3: 14,
    text4: 12,
  },
  color: {
    text: "#515358",
    red: "#BF2030",
    lightText: "#A4A4A4",
    white: "#FFFFFF",
    back: "#F7F6F6",
    stroke: "#E1E1E1",
    error: "#BF2030",
    disabled: "#DDDDDD",
    gray: "#ededed",
    gray1: "#C9C9C9",
    listBody: "#F5F4F4",
    darkGray: "#4C5059",
    background: "rgb(63, 62, 62, 0.8)",
  },
  space(...args) {
    const result = (args.length ? [...args] : [1]).reduce((str, curr) => `${str} ${curr}px`, "");
    return result;
  },
  css: {
    borderRadius: "8px;",
    centered: "position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);",
    transition: "all 300ms ease-in-out;",
    boxShadow: "0px 4px 6px -2px rgba(0,0,0,0.5);",
  },
};

export default theme;
